<template>
  <error-404 />
</template>

<script>
import Error404 from '@/components/error/404'

export default {
  components: {
    Error404
  }
}
</script>

<style lang="scss" scoped="scoped">
</style>
